/**
 * selectors/app.ts
 * desc: selectors for app
 * note:
 */

import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from '../index';

const selectApp = (state: RootState) => state.app;

export const selectHasUnsavedChanges = createSelector(selectApp, (app) => app.hasUnsavedChanges);
